import { useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useQuery } from 'react-query';

const useFetchOtherDocuments = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchOtherDocuments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/otherDocuments/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        throw new Error('Failed to fetch other documents.');
      }

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'An error occurred while fetching other documents.');
    }
  };

  return useQuery(['otherDocuments', vesselId], fetchOtherDocuments);
};

export default useFetchOtherDocuments;
